import React from "react";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { LABEL_PRESETS } from "@/lib/labelSizes";
import { FieldLabel, SectionLabel } from "./FormPrimitives";

export const LabelSizeCard = ({ form, onPresetChange, onCustomSize }) => (
  <Card className="border-zinc-200 shadow-sm">
    <div className="p-6 md:p-8">
      <SectionLabel hint="Print">Label Size</SectionLabel>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-end">
        <div className="md:col-span-2">
          <FieldLabel htmlFor="label_preset">Preset</FieldLabel>
          <Select
            value={form.label_size.preset}
            onValueChange={onPresetChange}
          >
            <SelectTrigger className="h-11" data-testid="select-label-preset">
              <SelectValue placeholder="Choose a size" />
            </SelectTrigger>
            <SelectContent>
              {LABEL_PRESETS.map((p) => (
                <SelectItem key={p.value} value={p.value} data-testid={`preset-${p.value}`}>
                  {p.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="grid grid-cols-2 gap-2">
          <div>
            <FieldLabel htmlFor="width_mm">W (mm)</FieldLabel>
            <Input
              id="width_mm"
              data-testid="input-label-width"
              type="number"
              min="20"
              value={form.label_size.width_mm}
              onChange={(e) => onCustomSize("width_mm", e.target.value)}
              className="h-11 font-mono"
            />
          </div>
          <div>
            <FieldLabel htmlFor="height_mm">H (mm)</FieldLabel>
            <Input
              id="height_mm"
              data-testid="input-label-height"
              type="number"
              min="20"
              value={form.label_size.height_mm}
              onChange={(e) => onCustomSize("height_mm", e.target.value)}
              className="h-11 font-mono"
            />
          </div>
        </div>
      </div>
    </div>
  </Card>
);
